import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')


export const state = {
  foros: {}
}

export const getters = {}

export const mutations = {
  FORO(state, request) {
    state.cached = request
  }
}

export const actions = {

  init({ state, dispatch }) { },

  fetchForos(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/api/foros/foro/${query}`).then((response) => {
      const request = response.data
      context.commit('FORO', request)
      return request
    })
  },
  fetchForumsLanding(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/api/foros/foro/get_forums_landing/${query}`)
  },
  fetchStakeHoldersForumsLanding(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/api/foros/foro/get_stake_holder_forums/${query}`)
  },
  fetchCategoriesForumsLanding(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/api/foros/foro/get_categories_forums/${query}`)
  },
  createUpdateForo(context, payload) {
    let promise = null
    if (payload.foro_id) {
      promise = axios.put(`${serverUrl}/api/foros/foro/${payload.foro_id}/`, payload)
    } else {
      promise = axios.post(`${serverUrl}/api/foros/foro/`, payload)
    }
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },
  createForoFile(context, payload) {
    const promise = axios.post(`${serverUrl}/api/foros/foro/${payload.foro_id}/save_file/`, payload.formData, { headers: { 'Content-Type': 'multipart/form-data' } })
    return promise
  },
  createForoPhoto(context, payload) {
    const promise = axios.post(`${serverUrl}/api/foros/foro/${payload.foro_id}/save_photo/`, payload.formData, { headers: { 'Content-Type': 'multipart/form-data' } })
    return promise
  },

  createForoCommentResponse(context, payload) {
    const promise = axios.post(`${serverUrl}/api/foros/comments/${payload.id}/save_response/`, payload)
    return promise
  },

  createForoComment(context, payload) {
    const promise = axios.post(`${serverUrl}/api/foros/comments/`, payload)
    return promise
  },

  changeForoState(context, payload) {
    const promise = axios.put(`${serverUrl}/api/foros/foro/${payload.foro_id}/change_state/`, payload)
    return promise
  },

  changeForoRelease(context, payload) {
    const promise = axios.put(`${serverUrl}/api/foros/foro/${payload.foro_id}/show_foro/`, payload)
    return promise
  },
  getForoFile(context, foro_id) {
    const promise = axios.get(`${serverUrl}/api/foros/foro/${foro_id}/get_file/`)
    return promise
  },
}
